import { customInstance } from "../lib/api-client";
import type { CatalogImportResult } from "./model";

export type CatalogImportKind = "catalog" | "project-catalog";

export const importCatalogCsv = (
  kind: CatalogImportKind,
  csv: string,
  confirm = false,
): Promise<CatalogImportResult> => {
  const body = csv.replace(/^\uFEFF/, "");
  return customInstance<CatalogImportResult>({
    url: `/admin/${kind}/import`,
    method: "POST",
    headers: { "Content-Type": "text/csv; charset=UTF-8" },
    data: body,
    params: { confirm },
    timeout: 60_000,
  });
};

export const exportCatalogCsv = (kind: CatalogImportKind) =>
  customInstance<string>({
    url: `/admin/${kind}/export`,
    method: "GET",
    headers: { Accept: "text/csv; charset=UTF-8" },
    responseType: "text",
  });
